/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Product_ListInputs */

const vi_nav_product_list = /** @type {(inputs: Nav_Product_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách`)
};

/**

* @param {Nav_Product_ListInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_product_list = /** @type {((inputs?: Nav_Product_ListInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Product_ListInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_product_list(inputs)
});